import borderRadius from "./borderRadius";
import boxShadow from "./boxShadow";
import colors from "./colors";
import fontFamily from "./fontFamily";
import typography from "./typography";
var theme = {
  fontFamily: fontFamily,
  typography: typography,
  colors: colors,
  boxShadow: boxShadow,
  borderRadius: borderRadius
};
export default theme;